
import { Form } from "antd"
import Wrapper from "./Preview/Wrapper";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const FormPreview = ({ formElements, formType, conditions, spaceData = {}, defaultValues = {} }) => {
    const { i18n } = useTranslation();
    const [form] = Form.useForm();
    // `preserve: true` reads the whole form store rather than the registered-field
    // snapshot. A hidden field is unmounted, so it drops out of the plain snapshot -
    // a condition that reads that field would then see it as empty and stop firing,
    // even though the form still holds its value. Conditions have to be evaluated
    // against the full store.
    let formValues = Form.useWatch([], { form, preserve: true }) || {};

    useEffect(() => {
        form.resetFields();
        if (defaultValues && Object.keys(defaultValues).length > 0) {
            form.setFieldsValue({ ...defaultValues })
        }
    }, [form, defaultValues])
   



    return (
        <div className="">
            <Form form={form} layout="vertical" style={{ display: "flex", flexWrap: "wrap" }}>                {
                    formElements?.map((data, index) => {
                        return <Wrapper key={data.id || index} data={data} form={form} formValues={formValues} previewMode={true} conditions={conditions} formType={formType} formElements={formElements} spaceData={spaceData} defaultFormValues={defaultValues} lng={i18n.language} />
                    })
                }
            </Form>
        </div>
    )
}

export default FormPreview
